import { Box, IconButton, styled, Typography } from '@mui/material';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import Button from '../../Button/Button';
import { StyledStrongProps } from '../../../types/KeywordsTypes';

export const StyledModalBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 925,
  minHeight: 375,
  backgroundColor: theme.palette.background.paper,
  boxShadow: '24px',
  padding: 32,
  borderRadius: 24,
  display: 'flex',
  flexDirection: 'column',
}));

export const ModalHeader = styled(Box)({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
});

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: 24,
  right: 22,
  color: theme.palette.text.primary,
}));

export const UploadCSVContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginTop: 24,
  gap: 24
});

export const DescriptionText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  width: '94%',
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '16px',
  alignItems: 'center',
  letterSpacing: '-3%',
  color: theme.palette.text.tertiary,
}));

export const StyledLink = styled('a')(({ theme }) => ({
  marginLeft: 4,
  color: theme.palette.primary.dark,
  textDecoration: 'underline',
  transition: 'color 0.3s ease',
  '&:hover': {
    color: theme.palette.text.primary,
  },
}));

export const UploadContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  textAlign: 'center',
  width: 675,
  height: 145,
  borderRadius: 8,
  backgroundColor: theme.palette.background.default,
  alignSelf: 'center',
}));

export const UploadFileBox = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 500,
  marginTop: 10,
  alignItems: 'center',
  color: theme.palette.text.tertiary,
  '& span': {
    color: theme.palette.primary.dark,
    cursor: 'pointer',
  },
}));

export const CSVFileSizeLimitText = styled(Typography)(({ theme }) => ({
  fontSize: 12,
  fontWeight: 500,
  color: theme.palette.text.inputPlaceholder,
}));

export const FileUploadIcon = styled(FileUploadOutlinedIcon)(({ theme }) => ({
  color: theme.palette.secondary.main,
  marginRight: 8,
}));

export const FileInputLabel = styled('label')(({ theme }) => ({
  cursor: 'pointer',
  fontWeight: 600,
  color: theme.palette.primary.dark,
}));

export const ErrorText = styled(Typography)({
  color: 'red',
  fontSize: 12,
  fontWeight: 500,
});

export const UploadButtonContainer = styled(Box)({
  flex: 1,
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end'
});

export const StyledButton = styled(Button)({
  width: 134,
  height: 34,
});

export const StyledLoaderWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10
}));



export const ContentWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
});

export const StyledContent = {
  background: 'background.paper',
  padding: '8px',
  borderRadius: '8px',
};

export const FileNameWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  marginTop: 8
});

export const FileNameText = styled(Typography)(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: 14,
  fontWeight: 500,
  color: theme.palette.text.tertiary,
}));

export const FileDeleteIcon = styled(IconButton)({
  padding: 0,
  marginLeft: 8,
  '&:hover': {
    backgroundColor: 'transparent',
  },
});

export const StyledUploadFileIcon = styled(UploadFileOutlinedIcon)(({ theme }) => ({
  paddingRight: 8,
  height: 20,
  width: 20,
  color: theme.palette.secondary.main,
}));

// Error UI styled
export const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
});

export const StyledNormal = styled('span')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontSize: 14,
  fontWeight: 500,
  lineHeight: '16px',
  letterSpacing: '-0.36px',
  color: theme.palette.text.tertiary,
}));

export const StyledStrong = styled('strong')<StyledStrongProps>(
  ({ theme, size = 'default' }) => ({
    fontFamily: theme.typography.fontFamily,
    color: theme.palette.text.primary,
    fontSize: size === 'small' ? 14 : size === 'large' ? 24 : 16,
    fontWeight: 500,
    lineHeight: '20px',
    letterSpacing: '-0.36px',
  }),
);

export const StyledErrorIcon = styled(IconButton)(({ theme }) => ({
  padding: 0,
  paddingRight: 8,
}));

export const DomainsErrorContainer = styled(Box)({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  marginTop: 24,
  gap: 24,
});

export const ErrorContent = styled(Box)(({ theme }) => ({
  background: theme.palette.background.tertiary,
  padding: 16,
  display: 'flex',
  flexDirection: 'column',
  borderRadius: 13,
}));